var map = {
	"./calc_off.svg": "3cbd",
	"./calc_on.svg": "720e",
	"./field_off.svg": "0204",
	"./field_on.svg": "e8c3",
	"./logo_off.svg": "f6aa",
	"./logo_on.svg": "8d9d",
	"./results_off.svg": "e2eb",
	"./results_on.svg": "4c2f",
	"./well_off.svg": "4edb",
	"./well_on.svg": "a8e4",
	"./wellbore_activated.svg": "c43e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "81a9";